import Vue from 'vue';
import Vuex from 'vuex';

import Front from './front/Front.vue';

if (window.screen.availWidth >= 450) {
  Vue.config.productionTip = false;
  Vue.use(Vuex);

  const store = new Vuex.Store({
    state: {
      paused: false,
    },
    mutations: {
      setPaused(state, newValue) {
        state.paused = newValue;
      },
    },
  });

  new Vue({
    render: (h) => h(Front),
    store,
  }).$mount('#video');
}
